import React from "react";

import { cn } from "../../lib/utils";

function Skeleton({
  className,
  style,
  ...props
}: Readonly<React.ComponentProps<"div">>) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        "rounded-md bg-shimmer-light dark:bg-shimmer-dark animate-shimmer",
        className
      )}
      style={{
        backgroundSize: "200% 100%",
        ...style
      }}
      {...props}
    />
  );
}

export { Skeleton };
